import { useState } from "react";

import { useTranslation } from "react-i18next";

import { RecoveryCodesIcon } from "@dotnet/telematics-design-system";

import { BUTTON_COLORS } from "components/DesignComponents/Button/types/enums";

import ContentFrameGroup from "../../ContentFrameGroup";
import TwoFactorRecoveryCodesModal from "./TwoFactorRecoveryCodesModal";

const TwoFactorRecoveryCodes = () => {
    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);

    const openDialog = () => setIsOpen(true);
    const closeDialog = () => setIsOpen(false);

    return (
        <>
            <ContentFrameGroup
                title={t("Security##recovery codes##settings##title")}
                description={t(
                    "Security##recovery codes##settings##description"
                )}
                buttonText={t("Button##generate")}
                buttonColor={BUTTON_COLORS.Secondary}
                icon={<RecoveryCodesIcon />}
                onButtonClick={openDialog}
            />

            <TwoFactorRecoveryCodesModal isOpen={isOpen} close={closeDialog} />
        </>
    );
};

export default TwoFactorRecoveryCodes;
